module.exports = {"type":"Start typing...","enter":"Press Enter","vertical":"to navigate","horizontal":"to navigate","select":"to select","esc":"to close"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/shortcuts.json
// module id = 668
// module chunks = 247 1430